(function () {
    angular
        .module('bizPartEngage')
        .directive('bizOneGoalTask', bizOneGoalTaskDirective);

    bizOneGoalTaskDirective.$inject = ['bizCore'];

    function bizOneGoalTaskDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {
                task: '=',
            },
            templateUrl: bizCoreProvider.getView(
                'bizOneGoalTaskDirective',
                'FrontEnd/Modules/EngagementGoals/Views/Directives/oneTask.html'
            ),
            bindToController: true,
            controller: bizOneGoalTaskController,
            controllerAs: 'vm',
        };

        bizOneGoalTaskController.$inject = [
            'modules.goals.service',
            '$q',
            '$scope',
            '$state',
            '$mdToast',
            'bizValidationService',
            '$mdDialog',
        ];

        return directive;

        function bizOneGoalTaskController(
            engagementGoalsService,
            $q,
            $scope,
            $state,
            $mdToast,
            bizValidationService,
            $mdDialog
        ) {
            var vm = this;

            vm.SelectedPeriod = engagementGoalsService.GetSelectedPeriod();
            vm.DateSettings = {
                min: moment(vm.SelectedPeriod.StartDate),
                max: moment(vm.SelectedPeriod.EndDate),
            };

            vm.EditMode = false;
            vm.taskIsLoadedDefer = $q.defer();
            vm.taskIsLoaded = vm.taskIsLoadedDefer.promise;

            vm.Settings = {
                display: 'bubble',
                touchUi: false,
                buttons: ['Ok', 'Cancel'],
                dateWheels: 'mmyy',
                max: moment().add(1, 'day'),
            };

            vm.Init = Init;
            vm.GetActivities = GetActivities;
            vm.Save = Save;
            vm.CancelEdit = CancelEdit;
            vm.SetTaskLoaded = SetTaskLoaded;
            vm.SetTaskDates = SetTaskDates;
            vm.CompleteTask = CompleteTask;
            vm.GetGoalTypes = GetGoalTypes;
            vm.DeleteTask = DeleteTask;
            vm.UncompleteTask = UncompleteTask;

            function CompleteTask() {
                engagementGoalsService
                    .CompleteTask(vm.task)
                    .then(CompleteTaskCallback);

                function CompleteTaskCallback(response) {
                    vm.task.IsCompleted = true;
                    $state.reload();
                    //$mdToast.show(
                    //    $mdToast.simple()
                    //        .textContent('The task has been completed')
                    //        .position('bottom right')
                    //);
                }
            }

            function UncompleteTask() {
                engagementGoalsService
                    .UncompleteTask(vm.task.Id)
                    .then(UncompleteTaskCallback);

                function UncompleteTaskCallback(response) {
                    vm.task.IsCompleted = false;
                    $state.reload();
                }
            }

            function CancelEdit() {
                if (~~vm.task.Id > 0) {
                    vm.EditMode = false;
                } else {
                    $state.go('base.modules.goals.tasks');
                }
            }

            function GetActivities() {
                engagementGoalsService
                    .GetActivitiesByGoalDate()
                    .then(GetActivitiesCallback);

                function GetActivitiesCallback(response) {
                    var activities = BizPartCoreHelpers.getResponseValue(
                        response,
                        []
                    );
                    //for (var i = 0; i < activities.length; i++) {
                    //    //activities[i].Name = activities[i].GoalName + ': ' + activities[i].Text;
                    //}
                    vm.AllActivities = activities;

                    //if (vm.AllActivities.length) {
                    //    vm.SelectedActivity = vm.AllActivities[0];
                    //}

                    $q.when(vm.taskIsLoaded).then(function () {
                        var goalFilteredActivities = [];
                        for (var i = 0; i < vm.AllActivities.length; i++) {
                            if (
                                vm.AllActivities[i].Id ===
                                vm.task.LinkedObjectId
                            ) {
                                vm.SelectedActivity = vm.AllActivities[i];
                                goalFilteredActivities.push(
                                    vm.AllActivities[i]
                                );
                            } else if (
                                vm.AllActivities[i].GoalId === vm.task.GoalId
                            ) {
                                goalFilteredActivities.push(
                                    vm.AllActivities[i]
                                );
                            }
                        }

                        if (vm.task.GoalId) {
                            vm.AllActivities = goalFilteredActivities;
                        }
                    });
                }
            }

            function DeleteTask() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Radera')
                    .textContent(
                        'Är du säker på att du vill radera denna "Att göra"?'
                    )
                    .ok('Ja')
                    .cancel('Avbryt');

                $mdDialog.show(confirm).then(
                    function () {
                        engagementGoalsService
                            .DeleteTask(vm.task.Id)
                            .then(function (response) {
                                $state.go('base.modules.goals.engagementgoals');
                            });
                    },
                    function () {}
                );
            }

            function Save() {
                if (vm.MyForm && !bizValidationService.FormValid(vm.MyForm))
                    return;

                vm.task.DateLocal = vm.EditDate;
                vm.task.LinkedObjectId = vm.SelectedActivity.Id;
                vm.task.GoalTypeId = vm.SelectedType ? vm.SelectedType.Id : 0;

                var saveData = {
                    Todo: vm.task,
                    Comment: vm.NewComment,
                };

                if (
                    saveData.Todo.GoalValue &&
                    typeof saveData.Todo.GoalValue !== 'number'
                )
                    saveData.Todo.GoalValue = ~~saveData.Todo.GoalValue.replace(
                        /\s/g,
                        ''
                    );

                engagementGoalsService
                    .CreateUpdateTask(saveData)
                    .then(CreateUpdateTaskCallback);

                function CreateUpdateTaskCallback(response) {
                    // if(~~vm.task.Id <= 0) {

                    // }

                    window.history.back();

                    // vm.NewComment = undefined;
                    // vm.task = BizPartCoreHelpers.getResponseValue(response);
                    // vm.SetTaskDates();
                    // vm.EditMode = false;

                    // $mdToast.show(
                    //     $mdToast.simple()
                    //         .textContent('The task has been saved')
                    //         .position('bottom right')
                    // );
                }
            }

            function SetTaskDates() {
                if (vm.task.DateLocal) {
                    vm.EditDate = moment(vm.task.DateLocal);
                }
            }

            function GetGoalTypes() {
                engagementGoalsService
                    .GetGoalTypes()
                    .then(GetGoalTypesCallback);

                function GetGoalTypesCallback(response) {
                    vm.GoalTypes = BizPartCoreHelpers.getResponseValue(
                        response,
                        []
                    );

                    $q.when(vm.taskIsLoaded).then(function () {
                        if (vm.task.GoalTypeId) {
                            vm.SelectedType = vm.GoalTypes.GetItemByValue(
                                'Id',
                                vm.task.GoalTypeId
                            );
                        }
                    });
                }
            }

            function Init() {
                vm.GetGoalTypes();
                if (vm.task && vm.task.Id === 'new') {
                    vm.task = {
                        Text: '',
                        GoalId: vm.task.GoalId,
                        LinkedObjectId: vm.task.ActivityId,
                    };
                    //vm.EditDate = engagementGoalsService.GetSelectedQuarter().Date,
                    vm.EditMode = true;
                }
                vm.GetActivities();
            }

            function SetTaskLoaded() {
                vm.SetTaskDates();
                vm.taskIsLoadedDefer.resolve('');
                vm.unbindTaskWatch();
            }

            vm.unbindTaskWatch = $scope.$watch('vm.task', function () {
                if (vm.task !== undefined) {
                    vm.SetTaskLoaded();
                }
            });

            //does not work :()
            //$scope.$watch("vm.SelectedActivity", function () {
            //    if (vm.SelectedActivity) {
            //        vm.TaskDatePicker.settings.min = moment(vm.SelectedActivity.GoalFromDate);
            //        vm.TaskDatePicker.settings.max = moment(vm.SelectedActivity.GoalToDate);
            //    }
            //});

            vm.$onInit = vm.Init;
        }
    }
})();
